import { api } from './api-client';

export interface Product {
  productId: string;
  sherwebSku: string;
  chargebeeItemPriceId: string;
  description: string;
  metadata: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export interface Subscription {
  subscriptionId: string;
  customerId: string;
  productId: string;
  chargebeeSubscriptionId: string;
  status: 'active' | 'cancelled' | 'pending';
  startDate: string;
  endDate: string;
  renewalDate: string;
  createdAt: string;
  updatedAt: string;
}

export interface License {
  licenseId: string;
  subscriptionId: string;
  licenseKey: string;
  status: 'issued' | 'active' | 'expired';
  issueDate: string;
  expirationDate: string;
  metadata: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export const licensesApi = {
  // Products
  getProducts: () => 
    api.get<Product[]>('/products'),
  
  getProduct: (productId: string) => 
    api.get<Product>(`/products/${productId}`),
  
  // Subscriptions
  getSubscriptions: (customerId?: string) => 
    api.get<Subscription[]>(`/subscriptions${customerId ? `?customer_id=${customerId}` : ''}`),
  
  getSubscription: (subscriptionId: string) => 
    api.get<Subscription>(`/subscriptions/${subscriptionId}`),
  
  createSubscription: (data: { 
    customerId: string, 
    productId: string, 
    chargebeeSubscriptionId: string,
    status: 'active' | 'cancelled' | 'pending',
    startDate: string,
    endDate: string,
    renewalDate: string
  }) => 
    api.post<Subscription>('/subscriptions', data),
  
  updateSubscription: (subscriptionId: string, data: { 
    status?: 'active' | 'cancelled' | 'pending',
    endDate?: string,
    renewalDate?: string
  }) => 
    api.put<Subscription>(`/subscriptions/${subscriptionId}`, data),
  
  // Licenses
  getLicenses: (subscriptionId?: string) => 
    api.get<License[]>(`/licenses${subscriptionId ? `?subscription_id=${subscriptionId}` : ''}`),
  
  getLicense: (licenseId: string) => 
    api.get<License>(`/licenses/${licenseId}`),
  
  createLicense: (data: { 
    subscriptionId: string,
    licenseKey: string,
    status: 'issued' | 'active' | 'expired',
    issueDate: string,
    expirationDate: string,
    metadata?: Record<string, any>
  }) => 
    api.post<License>('/licenses', data),
  
  updateLicense: (licenseId: string, data: { 
    status?: 'issued' | 'active' | 'expired',
    expirationDate?: string,
    metadata?: Record<string, any>
  }) => 
    api.put<License>(`/licenses/${licenseId}`, data),
};
